import axios from 'axios';
import { api } from './api';

const API_URL =
  (process.env.REACT_APP_API_URL || "http://localhost:8000") + "/api";


export const authService = {
  login: async (email, senha, options = {}) => {
    const tenantId = String(options?.tenantId || '').trim();
    const config = tenantId
      ? { headers: { 'X-Tenant-ID': tenantId } }
      : undefined;
    const response = await axios.post(`${API_URL}/auth/login`, { email, senha }, config);
    return response.data;
  },

  cadastro: async (userData) => {
    const response = await axios.post(`${API_URL}/auth/cadastro`, userData);
    return response.data;
  },

  recuperarSenha: async (email) => {
    const response = await axios.post(`${API_URL}/auth/recuperar-senha`, { email });
    return response.data;
  },

  resetarSenha: async (token, nova_senha, confirmar_senha) => {
    const response = await axios.post(`${API_URL}/auth/resetar-senha`, {
      token,
      nova_senha,
      confirmar_senha,
    });
    return response.data;
  },

  refresh: async (refresh_token) => {
    const response = await axios.post(`${API_URL}/auth/refresh`, { refresh_token });
    return response.data;
  },

  getCurrentUser: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) return null;

    try {
      const response = await api.get('/api/auth/me');
      return response.data || null;
    } catch (error) {
      const status = error?.response?.status;

      if (status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('token_type');
        return null;
      }

      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
  },

  getAuthHeader: () => {
    const token = localStorage.getItem('access_token');
    if (!token) return {};
    return {
      Authorization: `Bearer ${token}`,
    };
  },
};
